export default "__VITE_ASSET__5764d5cd__"